import { useEffect, useState } from 'react';
import { fetchSettings } from '../lib/adminApi';
import { CHURCH } from '../mock/mock';

// Module-level cache so multiple components share one fetch
let cache = null;
let inflight = null;

const FALLBACK = {
  serviceTime: CHURCH.serviceTime,
  address: CHURCH.address,
  city: CHURCH.city,
  email: CHURCH.email,
  phone: CHURCH.phone,
  poBox: CHURCH.poBox,
  poCity: CHURCH.poCity,
  facebookUrl: 'https://www.facebook.com/LivingHopeKnox/',
};

export const useSettings = () => {
  const [settings, setSettings] = useState(cache || FALLBACK);

  useEffect(() => {
    if (cache) { setSettings(cache); return; }
    if (!inflight) inflight = fetchSettings().catch(() => FALLBACK);
    let mounted = true;
    inflight.then((data) => {
      cache = { ...FALLBACK, ...data };
      if (mounted) setSettings(cache);
    });
    return () => { mounted = false; };
  }, []);

  return settings;
};

export const clearSettingsCache = () => { cache = null; inflight = null; };
